import apiM from '../GlobalEnv'

let i = 0;

export const postQuote = async (dataQ) => {
      const api = apiM + `/quote/${sessionStorage.getItem('mail')}/${sessionStorage.getItem('lStr')}/send`
      let init = {
            method:'post', 
            body:JSON.stringify(dataQ), 
            'headers':{'content-type':'application/json'},
            mode:'cors'
        }
        try {
            let res = await fetch(api,init)
            let mRes = await res
            // const {error} = await mRes.json()
            let ans =  mRes.json()
            let mAns = await ans
            
            // if(error) await mRes.json()
           
           if(mAns.success === undefined ){
                 return mAns
             }
           else return mAns.success
         
        }
         catch (error) {
               console.log(error.message)
               return error.message
        }

}

export const getQuo = () => {
      const api = apiM + `/quote/${sessionStorage.getItem('mail')}`
      return async dispatch => {
            try {
                let res = await fetch(api)
            //     console.log(await res)
                let resData = res.json()

                let dData = await resData
            //     console.log(dData)
 
            dispatch(updateQuoFromApi(dData))
            } 
            catch (error) {
            //      console.log(error)
                  
            }
      }
}
export const updateQuoFromApi = (data) => ({
      'type': 'UPDATE_QUO_API',
      'load': [...data]
})

export const addQuote = quote => ({
     'type': 'ADD_Q',
      'load': {quote, _id: i++}
})

export const removeQuote = _id => ({
      'type': 'REM_Q',
      'load': _id
})


 